import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button, Segmented } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setAgeingFilters } from "../AgeingSlice";
import { fetchCustomerAgeing, fetchVendorAgeing } from "../AgeingThunk";
import { fetchCustomers, fetchLocations, fetchSuppliers } from "../../../../store/commonThunks/lookups";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";



const AgeingFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.ageing);
  const lookups = useSelector((state) => state.lookups);

  useEffect(() => {
    dispatch(fetchCustomers({ type: "debitor" }));
    dispatch(fetchLocations());
    dispatch(fetchSuppliers()); // fetch vendors/creditors
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch(setAgeingFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (filters.reportType === "Customer") {
      dispatch(fetchCustomerAgeing(filters)).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          messageApi.success("Customer Ageing Report loaded ✅");
        } else {
          messageApi.error("Failed to fetch records ❌");
        }
      });
    } else {
      dispatch(fetchVendorAgeing(filters)).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          messageApi.success("Vendor Ageing Report loaded ✅");
        } else {
          messageApi.error("Failed to fetch records ❌");
        }
      });
    }
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} style={{ alignItems: "center" }}>
        {/* Report Type Toggle */}
        <Col xs={24} sm={24} md={8} lg={6} xl={4}>
          <label>Report Type</label>
          <div style={{ marginTop: 4 }}>
            <Segmented
              options={["Customer", "Vendor"]}
              value={filters.reportType}
              onChange={(val) => handleFilterChange("reportType", val)}
              block
            />
          </div>
        </Col>

        {/* Customer filter */}
        {filters.reportType === "Customer" && (
          <>
            <Col xs={24} sm={12} md={8} lg={6} xl={4}>
              <label>Customer (optional)</label>
              <SearchListAutoComplete
                optionsList={lookups?.customers
                  ?.filter((acc) => acc.acc_type_name !== "Insurance")
                  ?.map((acc) => ({
                    sale_id: acc.acc_id,
                    display_text: acc.acc_name,
                  }))}
                onSelect={(obj) =>
                  handleFilterChange("customerId", obj?.sale_id || null)
                }
                placeholder="All Customers"
                showAddNew={false}
              />
            </Col>
          
          </>
        )}

        {/* Vendor filter */}
        {filters.reportType === "Vendor" && (
          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <label>Vendor (optional)</label>
            <SearchListAutoComplete
              optionsList={lookups?.suppliers?.map((s) => ({
                sale_id: s.acc_id,
                display_text: s.acc_name,
              }))}
              onSelect={(obj) =>
                handleFilterChange("supplierId", obj?.sale_id || null)
              }
              placeholder="All Vendors"
              showAddNew={false}
            />
          </Col>
        )}

        {/* Get Report Button */}
        <Col
          xs={24}
          sm={12}
          md={8}
          lg={6}
          xl={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
          >
            Get Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default AgeingFilters;